import { Translator } from 'Translator';
import LoadingDots from 'components/LoadingDots';
import React, { memo } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { generatePathnameWithLangCode, getPath } from 'utils/RouteHelper';
import { useUser } from '~/authentication/store';

const RedirectRoute = memo(
  () => {
    const searchParams = new URLSearchParams();
    searchParams.set('returnTo', getPath());
    console.log('url$ rendering redirect route');
    return (
      <Redirect
        to={{
          pathname: generatePathnameWithLangCode(
            '/signup/',
            Translator.getLanguageCode(),
          ),
          state: {
            modal: true,
            returnPath: document.location.pathname,
            returnQuery: document.location.search,
          },
          search: searchParams.toString(),
        }}
      />
    );
  },
  () => true,
);

type PrivateRouteProps = RouteProps;

const PrivateRoute = ({ component, path, ...props }: PrivateRouteProps) => {
  const { isLoggedIn, loading } = useUser();
  console.log('url$ PrivateRoute', isLoggedIn, loading, component);

  if (loading) {
    return <LoadingDots />;
  }

  if (!isLoggedIn && !loading) {
    return <RedirectRoute />;
  }

  const FinalComponent = isLoggedIn ? component : RedirectRoute;

  return (
    <Route path={path}>
      <FinalComponent {...props} />
    </Route>
  );
};

export default PrivateRoute;
